import React from "react";
import PdfBase from "./PdfBase";
import { generateInvestIncomePdf } from "./generator";
import ExcelBase from "../Excel/ExcelBase";

const PdfGenerator = ({
  schedule,
  company,
  investIncomeRows,
  expensesRows,
  totalInvestIncome,
  totalExpenses,
  netIncome,
  foreignTaxSettings,
  shareOfExpenses,
  notes,
  reviewNotes,
}) => {
  const sharedArgs = [
    schedule,
    company,
    investIncomeRows,
    expensesRows,
    totalInvestIncome,
    totalExpenses,
    netIncome,
    foreignTaxSettings,
    shareOfExpenses,
    notes,
    reviewNotes,
  ];
  return (
    <>
      <PdfBase
        company={company}
        enableDraftView
        generatePdf={(forView) =>
          generateInvestIncomePdf(forView, ...sharedArgs)
        }
        downloadName={schedule.name || schedule.type}
      />
      <ExcelBase
        generateExcel={(forView) =>
          generateInvestIncomePdf(forView, ...sharedArgs, true)
        }
      />
    </>
  );
};

export default PdfGenerator;
